<div *ngIf="loading">
  Loading...
</div>
<div class="content">
  <div class="content-background">

  </div>
  <div class="marketing-video-container">
    <div class="marketing-text">
      <h1>Sporty's Pilot Training Online</h1>
      <p>Discover what aviation’s best flight training courses have to offer.</p>
    </div>
    <div class="marketing-video">
      <!--<div class="video-responsive">-->
      <!--<iframe width="720" height="480" src="https://www.youtube.com/embed/lqu-hWrm5mg" frameborder="0"
              allow="accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture"
              allowfullscreen></iframe>
      -->
      <div>
        <video appVideojs class="video-js" controls muted playsinline preload="none"></video>
      </div>

      <!--      </div>-->
    </div>
  </div>

  <div *ngIf="!loading" class="course-content-container">
    <div class="navigation-container">
      <div class="btn-group" dropdown>
        <button id="button-basic" dropdownToggle type="button" class="btn btn-white btn-round dropdown-toggle"
          aria-controls="dropdown-basic">Filter&nbsp;<span class="caret"></span>
        </button>
        <ul id="dropdown-basic" *dropdownMenu class="dropdown-menu dropdown-menu-right" role="menu"
          aria-labelledby="button-basic">
          <li role="menuitem">
            <a class="dropdown-item" [ngClass]="{'active': showing === 'ALL'}" (click)="showAll($event)"
              href="#">All</a>
          </li>
          <li role="menuitem" *ngFor="let tag of tags">
            <a class="dropdown-item" [ngClass]="{'active': showing === tag}" (click)="show($event, tag)"
              href="#">{{tag}}</a>
          </li>
        </ul>
      </div>
    </div>
    <!--
    <div class="navigation-container navigation-container-tablet">
      <ul class="nav flex-md-row flex-lg-column">
        <li class="nav-item">
          <a class="nav-link" (click)="showAll($event)">All</a>
        </li>
        <li class="nav-item" *ngFor="let tag of tags">
          <a class="nav-link" (click)="show($event, tag)">{{tag}}</a>
        </li>
      </ul>
    </div>
    -->


    <div class="courses-container card-container">
      <ng-template ngFor let-courseGroup [ngForOf]="( unownedCourseGroups | tagFilter:selectedTags:showAllCourses)">
        <ng-template [ngIf]="courseGroup.courses.length > 1">
          <app-course-group-card class="course-wrapper" [courseGroup]="courseGroup" [purchased]="false">
          </app-course-group-card>
        </ng-template>
        <ng-template ngFor let-course [ngForOf]="courseGroup.courses">
          <app-course-card class="course-wrapper"
            *ngIf="courseGroup.courses.length === 1 && !course.hideDemo === true" [course]="course"
            [purchased]="false"></app-course-card>
        </ng-template>
      </ng-template>
    </div>
  </div>
  <div class="right-container">
    <!--
    <div class="navigation-container">
      <h3>Course Categories:</h3>
      <ul class="nav flex-md-row flex-lg-column">
        <li class="nav-item">
          <a class="nav-link" (click)="showAll($event)">All</a>
        </li>
        <li class="nav-item" *ngFor="let tag of tags">
          <a class="nav-link" (click)="show($event, tag)">{{tag}}</a>
        </li>
      </ul>
    </div>
    -->
    <div app-marketing-card></div>
    <div app-feed-card [name]="'STUDENT_PILOT_NEWS'"
      [background]="'https://dl.videos.sportys.com/onlinecourse/images/SPN_blog.jpg'"></div>
    <div app-feed-card [name]="'IPAD_PILOT_NEWS'"
      [background]="'https://dl.videos.sportys.com/onlinecourse/images/IPN_blog.jpg'"></div>
  </div>
</div>
